import clsx from 'clsx';
import { ArrowRight } from 'lucide-react';
import { Button } from './Button';

/**
 * BookDemoButton — THE single, reusable primary "Book a Demo" CTA.
 *
 * One source of truth for the site's main call-to-action. Built on the
 * canonical <Button> (variant="cta"), so it inherits the design system's
 * sizing, focus ring, and disabled handling — no parallel styling.
 *
 * Visual: blue gradient pill (--gradient-cta, #0098FF→#0057D4),
 * white text, premium hover = subtle lift (-2px) + deeper brand shadow +
 * arrow nudge. Matches the established CTA hover language (HeroTwo PrimaryCta,
 * .lb-aihero__cta) while reading as the primary action everywhere.
 *
 * Works on light, tinted, and dark sections (white text + gradient hold
 * contrast on all site backgrounds). Keyboard focus shows a brand-dark ring
 * with offset, visible on every background.
 *
 * Props:
 *   label    - button text (default "Book a Demo"; pass t('…') for i18n)
 *   href     - destination (default "#book-demo")
 *   size     - "sm" | "md" | "lg" (default) — passthrough to Button
 *   showArrow- trailing arrow that nudges on hover (default true)
 *   fullWidth, disabled, className, onClick, … - passthrough to Button
 */
export function BookDemoButton({
  label = 'Book a Demo',
  href = '#book-demo',
  size = 'lg',
  showArrow = true,
  className = '',
  ...rest
}) {
  return (
    <Button
      href={href}
      variant="cta"
      size={size}
      className={clsx('tracking-[-0.005em]', className)}
      iconRight={
        showArrow ? (
          <ArrowRight
            size={18}
            aria-hidden="true"
            className="transition-transform duration-150 group-hover:translate-x-1"
          />
        ) : null
      }
      {...rest}
    >
      {label}
    </Button>
  );
}
